import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';

import { APP_NAME, APP_NAVIGATION_ITEMS } from '../../constants/app.constants';
import { LayoutStateService } from '../../core/layout-state.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'idap-top-navigation',
  standalone: true,
  imports: [MenuModule, RouterLink, RouterLinkActive, TooltipModule],
  templateUrl: './top-navigation.component.html',
  styleUrl: './top-navigation.component.scss'
})
export class TopNavigationComponent {
  protected readonly appName = APP_NAME;
  protected readonly authService = inject(AuthService);
  protected readonly layoutState = inject(LayoutStateService);
  protected readonly mobileMenuOpen = signal(false);
  protected readonly navigationItems = APP_NAVIGATION_ITEMS;
  private readonly router = inject(Router);

  protected readonly userMenuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];

  protected get userInitial(): string {
    return this.authService.currentUser()?.username.slice(0, 1).toUpperCase() ?? 'A';
  }

  protected get userLabel(): string {
    return this.authService.currentUser()?.username ?? 'Admin';
  }

  protected get userRole(): string {
    return this.authService.currentUser()?.role ?? 'ADMIN';
  }

  protected closeMobileMenu(): void {
    this.mobileMenuOpen.set(false);
  }

  protected toggleMobileMenu(): void {
    this.mobileMenuOpen.update(isOpen => !isOpen);
  }

  private logout(): void {
    this.authService
      .logout()
      .subscribe(() => void this.router.navigate(['/login']));
  }
}
